import Services from './base-services'

const service = new Services('bookUserHighlight')

export default {
    delete(highlightId:any) {
        return service.post(`delete?highlightId=${highlightId}`)
    },
    newHighlight(data: any) {
        return service.post(`newHighlight`, data)
    },
}